import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconPrompts = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M47.919 3.394c-.557.14-1.085.548-1.33 1.03-.073.14-.2.535-.285.876-.469 1.89-1.19 3.337-2.357 4.726-1.537 1.833-3.38 2.994-5.754 3.625-.866.23-1.304.447-1.545.766-.663.878-.638 1.922.063 2.672.338.362.65.505 1.721.79a10.4 10.4 0 0 1 4.758 2.736c1.605 1.593 2.556 3.273 3.094 5.465.212.865.38 1.199.767 1.53.94.805 2.409.563 3.027-.499.084-.145.244-.623.355-1.063.574-2.283 1.496-3.882 3.175-5.508 1.494-1.447 3.03-2.287 5.08-2.779.61-.146.994-.34 1.29-.651a1.99 1.99 0 0 0-.393-3.087c-.204-.126-.57-.258-.992-.357-3.067-.725-5.686-2.79-7.195-5.673a12.2 12.2 0 0 1-.997-2.713c-.143-.652-.301-.987-.622-1.317-.456-.47-1.264-.718-1.86-.569m.318 7.608c-.23.39-1.174 1.597-1.682 2.152a17 17 0 0 1-1.137 1.11c-.555.484-.833.7-1.629 1.27l-.275.195.531.371c1.442 1.008 2.896 2.476 3.924 3.964.17.246.328.47.352.499.024.028.197-.174.385-.448a16.4 16.4 0 0 1 3.956-4.012l.534-.376-.339-.232c-1.556-1.064-3.26-2.784-4.209-4.248a8 8 0 0 0-.29-.431c-.006 0-.06.084-.12.186M4.925 20.375c-1.118.303-1.746 1.535-1.339 2.624.174.465.56.89 1.008 1.11l.366.179h26.816l.318-.157c.41-.2.84-.632 1.012-1.015.193-.426.194-1.209.003-1.625-.177-.384-.647-.854-1.032-1.032l-.301-.139-13.28-.012c-10.357-.01-13.344.005-13.571.067m.113 12.082c-.409.078-.898.388-1.165.738-.773 1.013-.43 2.428.735 3.038l.288.151 26.413.016 26.412.017.35-.13c.465-.175.889-.56 1.11-1.01.24-.49.254-1.23.03-1.69a2.25 2.25 0 0 0-1.025-1.001l-.362-.17-26.24-.01c-15.753-.005-26.362.015-26.546.05M4.751 44.65c-.36.127-.905.632-1.104 1.022-.132.259-.159.402-.159.855s.027.596.16.856c.19.374.57.768.925.957l.259.139h53.184l.256-.139c.358-.194.767-.635.94-1.013.202-.446.202-1.15-.002-1.606-.17-.382-.563-.786-.97-.997l-.288-.149-26.464-.011c-23.471-.01-26.495 0-26.737.086M4.928 56.7c-1.453.445-1.954 2.24-.922 3.302.157.162.45.372.652.466l.366.172h52.8l.362-.17a2.2 2.2 0 0 0 1.013-.99c.214-.425.225-1.194.024-1.632a2.3 2.3 0 0 0-.947-1.005l-.324-.171-26.432-.01c-14.538-.006-26.504.01-26.592.038" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconPrompts.displayName = 'IconPrompts';